import { render } from "./Russia.vue?vue&type=template&id=1eb2b47f&ts=true"
import script from "./Russia.vue?vue&type=script&lang=ts"
export * from "./Russia.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__